<script>
import { Line, mixins } from "vue-chartjs";
import AnalysisTooltip from "./analysis_tooltip.js";
import "chartjs-adapter-moment";

const { reactiveProp } = mixins;

export default {
	name: "line-chart",
	extends: Line,
	mixins: [reactiveProp],
	props: {
		chartData: Object,
		chartOptions: Object,
	},
	data() {
		return {
			defaultChartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				elements: {
					line: {
						tension: 0, // Does not seem to do anything at all if `cubicInterpolationMode` is set to 'monotone'
						cubicInterpolationMode: "monotone",
					},
				},
				scales: {
					x: {
						type: "time",
						display: true,
						gridLines: {
							display: true,
							color: "#ddd",
						},
					},
					y: {
						beginAtZero: true,
						display: true,
						gridLines: {
							display: true,
							color: "#ddd",
						},
					},
				},
				plugins: {}, // Stub so that plugins can be added
			},
		};
	},
	mounted() {
		this.initVerticalLinePlugin(); // Only relevant for backend graphs
		if (!this.chartOptions) {
			// @ts-expect-error
			this.chartOptions = Object.assign({}, this.defaultChartOptions);
		}
		// @ts-expect-error
		this.chartOptions.plugins.tooltip = AnalysisTooltip;
		// @ts-expect-error
		this.renderChart(this.chartData, this.chartOptions);
	},
	beforeDestroy() {},
	methods: {
		initVerticalLinePlugin() {
			// @ts-expect-error
			this.addPlugin({
				// Taken from https://stackoverflow.com/a/43092029, modified for Chart.JS 3
				getLinePosition: function (chart, linePosition) {
					const data = chart.getDatasetMeta(0).data; // First dataset is used to discover X coordinate of a point
					return data[linePosition] ? data[linePosition].x : null;
				},
				renderVerticalLine: function (
					chartInstance,
					linePosition,
					labelForLine,
					labelPosition,
				) {
					const lineLeftOffset = this.getLinePosition(
						chartInstance,
						linePosition,
					);
					if (lineLeftOffset === null) {
						return;
					}
					const scale = chartInstance.scales["y"];
					const context = chartInstance.ctx;

					// render vertical line
					context.beginPath();
					context.strokeStyle = "#ff0000";
					context.moveTo(lineLeftOffset, scale.top);
					context.lineTo(lineLeftOffset, scale.bottom);
					context.stroke();

					// write label
					context.fillStyle = "#999";
					context.textAlign = labelPosition;
					context.fillText(
						labelForLine,
						lineLeftOffset + 2,
						(scale.bottom - scale.top) * 0.03 + scale.top,
					);
				},

				afterDatasetsDraw: function (chart, easing) {
					if (!chart.config.data.linesAtIndex) {
						return;
					}
					chart.config.data.linesAtIndex.forEach((linePosition, index) => {
						let labelForLine;
						let labelPosition;
						if (index < chart.config.data.linesAtIndex.length - 1) {
							labelForLine = `${I18n.t("activerecord.models.phase.one")} ${index + 1}`;
							labelPosition = "left";
						} else {
							labelForLine = I18n.t("activerecord.attributes.phase.end_date");
							labelPosition = "right";
						}
						this.renderVerticalLine(
							chart,
							linePosition,
							labelForLine,
							labelPosition,
						);
					});
				},
			});
		},
	},
};
</script>
